
export default function PointGuide() {
  const pointRules = [
    {
      category: '通常ポイント',
      rate: '200円 = 2ポイント',
      description: '月間のご利用合計金額200円ごとに2ポイント付与（還元率1.0%）',
      icon: 'ri-shopping-cart-line',
    },
    {
      category: '外食利用',
      rate: '200円 = 4ポイント',
      description: '3,000円以上の外食利用で200円ごとに4ポイント付与（還元率2.0%）',
      icon: 'ri-restaurant-line',
    },
    {
      category: '分割・リボ払い',
      rate: '200円 = 4ポイント',
      description: '3回以上の分割払い・リボ払いで200円ごとに4ポイント付与',
      icon: 'ri-bank-card-line',
    },
    {
      category: 'JACCSモール',
      rate: '+0.5%〜12%',
      description: '500店以上のECショップでJデポが追加付与',
      icon: 'ri-global-line',
    },
  ];

  const shops = [
    { name: 'Apple', logo: 'https://www.jaccs.co.jp/goldtime_lp6/images/feature_shop01.png' },
    { name: 'agoda', logo: 'https://www.jaccs.co.jp/goldtime_lp6/images/feature_shop02.png' },
    { name: 'Yahoo!ショッピング', logo: 'https://www.jaccs.co.jp/goldtime_lp6/images/feature_shop04.png' },
    { name: 'ECモール', logo: 'https://www.jaccs.co.jp/goldtime_lp6/images/feature_shop05.png' },
  ];

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-3 text-center">
          ポイントの貯め方ガイド
        </h2>
        <p className="text-gray-600 text-center mb-12">貯まったポイントは自動で請求時値引きに！</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {pointRules.map((rule, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[#1A1A2E] to-[#16213E] rounded-full">
                  <i className={`${rule.icon} text-[#E8D48B] text-xl`}></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs">{rule.category}</p>
                  <p className="text-[#1A1A2E] text-xl font-bold">{rule.rate}</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">{rule.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <h3 className="text-xl font-bold text-[#1A1A2E] mb-6 text-center">
            JACCSモール対象ショップ（500店以上）
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {shops.map((shop, index) => (
              <div key={index} className="bg-[#F8F9FA] rounded-lg p-4 flex items-center justify-center h-20">
                <img src={shop.logo} alt={shop.name} className="max-h-12 object-contain" />
              </div>
            ))}
          </div>
          <p className="text-gray-500 text-xs text-center mt-6">
            ※JACCSモールを経由してお買い物するだけで、通常ポイントに加えてJデポが付与されます
          </p>
        </div>

        <div className="mt-8 bg-gradient-to-r from-[#1A1A2E] to-[#16213E] rounded-xl p-6 md:p-8">
          <h3 className="text-xl font-bold text-white mb-4 text-center">
            <i className="ri-lightbulb-line text-[#E8D48B] mr-2"></i>
            ポイント自動値引きの仕組み
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
            <div className="bg-white/10 rounded-lg p-4 text-center">
              <i className="ri-shopping-bag-line text-[#E8D48B] text-3xl mb-2"></i>
              <p className="text-white text-sm">カードでお買い物</p>
            </div>
            <i className="ri-arrow-right-line text-[#E8D48B] text-2xl hidden md:block"></i>
            <i className="ri-arrow-down-line text-[#E8D48B] text-2xl md:hidden"></i>
            <div className="bg-white/10 rounded-lg p-4 text-center">
              <i className="ri-coin-line text-[#E8D48B] text-3xl mb-2"></i>
              <p className="text-white text-sm">ポイントが貯まる</p>
            </div>
            <i className="ri-arrow-right-line text-[#E8D48B] text-2xl hidden md:block"></i>
            <i className="ri-arrow-down-line text-[#E8D48B] text-2xl md:hidden"></i>
            <div className="bg-white/10 rounded-lg p-4 text-center">
              <i className="ri-refresh-line text-[#E8D48B] text-3xl mb-2"></i>
              <p className="text-white text-sm">自動でJデポに交換</p>
            </div>
            <i className="ri-arrow-right-line text-[#E8D48B] text-2xl hidden md:block"></i>
            <i className="ri-arrow-down-line text-[#E8D48B] text-2xl md:hidden"></i>
            <div className="bg-white/10 rounded-lg p-4 text-center">
              <i className="ri-price-tag-3-line text-[#E8D48B] text-3xl mb-2"></i>
              <p className="text-white text-sm">請求時に自動値引き</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
